import { widget } from "@foretagsplatsen/widgetjs";

/*
  I am the widget used to render an action heading.
  I am composed of a title, and a collection of action I should render.
*/

/**
 * Todo: Add JSDoc comment
 */
function commandHeadingWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);

	const name = spec.name;
	const commandWidgets = spec.commandWidgets;

	that.getCommandWidgets = function () {
		return commandWidgets;
	};

	that.getName = function () {
		return name;
	};

	that.renderContentOn = function (html) {
		html.div(
			{ klass: "right-menu-section" },
			html.label(name),
			commandWidgets,
		);
	};

	return that;
}

export default commandHeadingWidget;
